import $ from 'jquery';

export default function initDatalayer() {
  $('.js-datalayer-eshoplink').click(function (e) {
    e.preventDefault();
    window.dataLayer.push({
      event: 'exit_to_eshop',
      exit_to_eshop_url: $(this).attr('href'),
    });
    if ($(this).attr('target') == '_blank') {
      window.open($(this).attr('href'));
    } else {
      window.location.href = $(this).attr('href');
    }
  });

  function EndRequestHandlerSubs(sender, args) {
    if ($('.NewsletterSubscription .InfoMessage').length > 0) {
      window.dataLayer.push({
        event: 'nwl_submit',
      });
    }
  }

  if ($('.NewsletterSubscription').length > 0) {
    Sys.WebForms.PageRequestManager.getInstance().add_endRequest(EndRequestHandlerSubs);
  }
}

export function datalayerQuizStart() {
  window.dataLayer.push({
    event: 'quiz_start',
  });
}

export function datalayerQuizQuestion(question) {
  window.dataLayer.push({
    event: 'quiz_question',
    quiz_question: question,
  });
}

export function datalayerQuizEnd(result) {
  window.dataLayer.push({
    event: 'quiz_finish',
    quiz_result: `${result}`,
  });
}
